export const ACTION_CODE = 'DASHBOARD_CONSULTANT_ACTIVITY' + '_ACTION';
